import { APPPROP } from '../constants/appProperty';

export function appPropertySet(appPropertyData) {
  return {
    type: APPPROP,
    payload: Promise.resolve(appPropertyData),
  };
}
